import axios from 'axios';
import { ProfileType } from 'types/shared/profile-type.enum';
import { Profile } from 'views/profiles-strategies/features/profiles/types/profile.type';

// GET
// /ewosapi/v2/planandprognosis/profile/{profileType}/{profileId}
export const getProfileByType = async (profileType: ProfileType, profileId: string): Promise<Profile> => {
  const res = await axios.get<Profile>(`/ewosapi/v2/planandprognosis/profile/${profileType}/${profileId}`);
  return res.data;
};
